import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SnotifyService } from 'ng-snotify';

@Injectable()
export class MassUploadService {

  constructor(private http: HttpClient, private snotifyService: SnotifyService) { }

  public uploadFile(base64String: string): Promise<any> {
    return new Promise((resolve, reject) => {
      var uploadFileDto = {
        FileData: base64String
      };

      this.http.post('/api/upload/uploadservicequestions', uploadFileDto).subscribe(data => {
        resolve(data);
        this.snotifyService.success('Successfully updated questions');
      }, error => {
        reject(error);
      });

    });
  }

  public uploadEquipmentFile(base64String: string): Promise<any> {
    console.log("SERVICE");
    console.log(base64String);
    return new Promise((resolve, reject) => {
      var uploadFileDto = {
        FileData: base64String
      };

      this.http.post('/api/massupload/upload', uploadFileDto).subscribe(data => {
        resolve(data);
        this.snotifyService.success('Successfully added equipment');
      }, error => {
        reject(error);
      });

    });
  }
}
